module.exports = __webpack_public_path__ + "static/media/au.68acccc0.svg";